module.exports = __webpack_public_path__ + "static/media/logo.97fcc4b2.png";